package com.rainbowclubs.rainbow.data.models

import kotlinx.serialization.Serializable

@Serializable
data class Club(
    val id: String,
    val name: String,
    val description: String?,
    val membershipData: List<MembershipDataItem>?,
    val clubImageUrl: String? = null,
)

@Serializable
data class MembershipDataItem(
    val label: String,
    val type: MembershipDataTypes,
    val options: List<String>? = null,
    val required: Boolean,
)

@Serializable
enum class MembershipDataTypes {
    SHORT_TEXT,
    LONG_TEXT,
    NUMBER,
    DROP_DOWN,
    MULTI_SELECT,
    DATE,
    BOOLEAN,
    UNKNOWN,
}
